import React from 'react'

import { Button } from '@fourthwall/components'

import * as S from './MailchimpGetStarted.styled'

type MailchimpGetStartedProps = {
  refreshLists: () => Promise<void>
  isRefreshing: boolean
}

export const MailchimpGetStarted = ({ refreshLists, isRefreshing }: MailchimpGetStartedProps) => {
  const handleGetStarted = async () => {
    try {
      await refreshLists()
    } catch (error) {
      console.error('Failed to refresh Mailchimp lists:', error)
    }
  }

  return (
    <S.Container>
      <S.Title>Connect with Mailchimp</S.Title>
      <S.Description>
        Integrate your Fourthwall shop with Mailchimp to automatically sync customer data and create
        powerful email marketing campaigns.
      </S.Description>
      <S.ButtonContainer>
        <Button
          label="Get Started"
          appearance="primary"
          loading={isRefreshing}
          disabled={isRefreshing}
          onClick={handleGetStarted}
        />
      </S.ButtonContainer>
    </S.Container>
  )
}
